const state = {
  is2FAEnforced: null,
};

const getters = {
  is2FAEnforced: (state) => state.is2FAEnforced,
};

const actions = {
  async getIs2FAEnforced({ commit }, mspId) {
    commit("setIs2FAEnforced", null);

    const res = await this._vm.$http.get(
      `/restapi/auth/msp/${mspId}/two-factor-auth/enforce`
    );

    commit("setIs2FAEnforced", res.data.enforce_twofa);
  },
  async putIs2FAEnforced({ commit }, { mspId, is2FAEnforced }) {
    await this._vm.$http.put(
      `/restapi/auth/msp/${mspId}/two-factor-auth/enforce`,
      {
        enforce: is2FAEnforced,
      }
    );

    commit("setIs2FAEnforced", is2FAEnforced);
  },
  async reset2FA(_, id) {
    await this._vm.$http.delete(`/restapi/auth/${id}/two-factor-auth/reset`, {
      id,
    });
  },
};

const mutations = {
  setIs2FAEnforced: (state, isEnforced) => (state.is2FAEnforced = isEnforced),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
